export const FORBIDDEN_COPY = {
  title: 'You do not have permission to access this page',
};

export const NOT_FOUND_COPY = {
  title: 'It seems like you are lost',
};
